/* eslint-disable */
import {Box, Card, Grid, Tooltip, Typography, withStyles} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useStyles} from "../../style";
import {useState} from "react";
import Chart from "react-apexcharts";
import InfoIcon from "@material-ui/icons/Info";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const BarDonutIF = ({ info, indicador, selectedIndice }) => {
    const theme = useTheme();
    const classes = useStyles([]);
    const [ indiceFinanciero, setIndiceFinanciero ] = useState(info[0].indice);

    const handleIndice = (indice) => {
        setIndiceFinanciero(indice);
        selectedIndice(indice);
    }

    const buildStyles = (data) => {
        return {
            options: {
                chart: {
                    width: '100px',
                    background: 'transparent',
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                    zoom: false,
                },
                plotOptions: {
                    radialBar: {
                        inverseOrder: false,
                        startAngle: 0,
                        endAngle: 360,
                        value: false,
                        track: {
                            background: '#dbdcdc',
                            strokeWidth: '130%',
                        },
                        dataLabels: {
                            showOn: 'always',
                            name: {
                                offsetY: 140,
                                show: true,
                                color: '#034886',
                                fontSize: '15px',
                                fontWeight: 700,
                            },
                            value: {
                                formatter: function(val){
                                    if (data.type === "percentage"){
                                        return `${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(val)}%`
                                    }else if (data.type === "number"){
                                        return `${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(val)}`
                                    }else if(data.type === "money"){
                                        return `$${formatCurrencyNumber(val)}`
                                    }
                                },
                                color: '#034886',
                                fontSize: '22px',
                                show: true,
                                offsetY: -5,
                                fontWeight: 700,
                            },
                        },
                        hollow: {
                            size: '55%',
                        },
                    },
                },
                colors: ['#034886','#034886'],
                dataLabels: {
                    enabled: false,
                },
                labels: [''],
                stroke: {
                    width: 0,
                },
                theme: {
                    mode: theme.palette.mode,
                },
            },
            series: data.series,
        }
    }


    function formatCurrencyNumber(number) {
        if (number === null || number === undefined) return '0';

        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let i = 0;
        let absNumber = Math.abs(number);

        while (absNumber >= 1000 && i < suffixes.length - 1) {
            absNumber /= 1000;
            i++;
        }

        const formatted = absNumber % 1 === 0 ? absNumber.toFixed(0) : absNumber.toFixed(1);
        const sign = number < 0 ? '-' : '';

        return `${sign}${formatted}${suffixes[i]}`;
        }


    return (
        <Box>
            <Grid
                sx={{
                    p: 1,
                    height: '100%',
                    width: '100%',
                }}
                container
                component={Card}
                className={classes.indicadoresFinancieros}
            >
                <Grid container justifyContent="space-evenly" spacing={1}>
                    {info.map(dataGraph => {
                        const chartStyle = buildStyles(dataGraph);
                        return (
                            <>
                                <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    onClick={() => handleIndice(dataGraph.indice)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <Box display="flex" justifyContent="center" className={indiceFinanciero === dataGraph.indice ? classes.selectedIndicatorBox : classes.indicatorBox}>
                                        <Box>
                                            
                                            <Box display="flex" alignItems="center" justifyContent="center" >
                                                <Typography className={classes.chartBarDonutText} textAlign={'center'}>
                                                    {dataGraph.indice}
                                                </Typography>
                                                <Box pr={1} display="flex" justifyContent="end">
                                                <LightTooltip title={dataGraph.definition}>
                                                    <InfoIcon style={{color: "#FCBE00", marginLeft: '5px'}}/>
                                                </LightTooltip>
                                            </Box>
                                            </Box>
                                            <div className={classes.chartBarCost}>
                                                <Chart
                                                    height="300px"
                                                    width="300px"
                                                    type="radialBar"
                                                    {...chartStyle}
                                                />
                                            </div>
                                        </Box>
                                    </Box>
                                </Grid>
                            </>)
                    })}
                </Grid>
            </Grid>
        </Box>
    )

}

export default BarDonutIF;